import React from "react";
import { Link } from "react-router-dom";

/**
 * Renova logo. On ivory/white surfaces we multiply-blend to drop the white
 * plate; on navy surfaces we seat it in a warm-ivory plate for contrast.
 */
export default function Logo({
  className = "",
  imgClass = "h-12 md:h-14 w-auto",
  onNavy = false,
  withLink = true,
  ariaLabel = "Renova Peptide Co. home",
}) {
  const img = (
    <img
      src="/assets/logo-trim.png"
      alt="Renova Peptide Co."
      className={`${imgClass} ${onNavy ? "" : "mix-blend-multiply"} select-none`}
      width="1112"
      height="341"
      decoding="async"
    />
  );

  const inner = onNavy ? (
    <span className="inline-flex items-center rounded-sm bg-[#F7F4EF] px-4 py-3 md:px-6 md:py-4">
      {img}
    </span>
  ) : (
    img
  );

  if (!withLink) return <span className={className}>{inner}</span>;

  return (
    <Link to="/" aria-label={ariaLabel} className={`inline-flex items-center ${className}`}>
      {inner}
    </Link>
  );
}
